import styled, { css } from 'styled-components'
import { theme, ifThen, breakpoint, breakpointMax } from 'utils/style'
import Input from 'components/Input/Input'
import Label from 'components/Label/Label'
import IconLink from 'components/IconLink/IconLink'

export const StyledWrapper = styled.div`
  ${({ type, smallSize, mediumSize, labelTop, labelMiddle }) => css`
  position: relative;
  margin-bottom: ${theme('spaces.xs')};
  padding-bottom: ${theme('spaces.m')};

  input[type="checkbox"],
  input[type="radio"] {
    margin-right: 0.5rem;
  }

  

    ${ifThen(
      labelTop,
      css`
        vertical-align: top;
      `,
    )}
    ${ifThen(
      labelMiddle,
      css`
        vertical-align: middle;
      `,
    )}
  }

  fieldset {
    position: relative;
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
  }

  ${ifThen(
    type === 'select',
    css`
      fieldset {
        position: relative;

        &::after {
          position: absolute;
          right: ${theme('spaces.s')};
          top: 50%;
          height: 0;
          width: 0;
          margin-top: -${theme('spaces.xs')};
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-top: 4px solid ${theme('colors.grayscale.medium')};
          content: '';
          pointer-events: none;
        }

        select::-ms-expand {
          display: none;
        }
      }
    `,
    '',
  )}
  ${ifThen(
    type === 'checkbox',
    css`
      ${breakpointMax('l')`
      vertical-align: top;

      label {
        width: 90%;
      }
    `}
    `,
    '',
  )}
  ${ifThen(
    smallSize,
    css`
      ${breakpoint('m')`
      width: 30%;
    `}
    `,
  )};

  ${ifThen(
    mediumSize,
    css`
      ${breakpoint('m')`
      width: 50%;
    `}
    `,
  )};
`};
`

export const StyledInput = styled(Input)`
  ${({ type }) => css`
    padding: 0 ${theme('spaces.l')} 0 ${theme('spaces.s')};
    height: 3.2rem;
    width: 100%;
    font-size: ${theme('fonts.size.base')};
    color: ${theme('colors.grayscale.darker')};

    ${ifThen(
      type === 'textarea',
      css`
        resize: none;
        height: 7rem;
        padding: ${theme('spaces.xs')};
      `,
    )}
  `};
`

export const StyledIconLink = styled(IconLink)`
  position: absolute;
  right: 5px;
  top: 50%;
  margin-top: calc(${theme('icons.size.s')} / -1.4);
  display: inline-block;
  height: ${theme('icons.size.s')};
  width: ${theme('icons.size.s')};
  cursor: auto;

  span {
    height: 100%;
    width: 100%;
  }

  svg .qs-header-cnx {
    fill: ${theme('colors.grayscale.dark')};
  }
`

export const StyledLabel = styled(Label)`
  ${({ hideLabel, lightFont, inline, restrictWidth }) => css`
    opacity: ${ifThen(hideLabel, '0', '1')};
    pointer: ${ifThen(hideLabel, 'none', 'auto')};
    transform: ${ifThen(hideLabel, 'translateY(5px)', 'translateY(0)')};
    transition: opacity 0.3s ease-in, transform 0.3s ease-in;
    font-weight: bold;
    font-size: ${theme('fonts.size.s')};
    line-height: 1;
    color: ${theme('colors.black')};
    margin-bottom: ${theme('spaces.xs')};

    ${ifThen(
      lightFont,
      css`
        font-weight: normal;
        font-size: ${theme('fonts.size.base')};
      `,
    )}

    ${ifThen(
      inline,
      css`
        display: inline-block;
      `,
      css`
        display: block;
      `,
    )}

  ${ifThen(
      restrictWidth,
      css`
        width: 90%;
      `,
      css`
        width: 100%;
      `,
    )}
  `}
`
